import React, { type TextareaHTMLAttributes } from "react";
import clsx from "clsx";

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  id?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  id,
  className = "",
  ...props
}) => {
  return (
    <div className="flex flex-col w-full">
      {label && (
        <label
          htmlFor={id}
          className="text-sm uppercase  tracking-widest text-slate-700 dark:text-slate-300  font-mono"
        >
          {label}
        </label>
      )}
      <textarea
        id={id}
        className={clsx(
          label && "mt-2",
          "block w-full rounded-md bg-white px-3 py-2 text-base text-slate-900 dark:bg-slate-900/80 dark:text-slate-200",
          "border border-slate-200 dark:border-slate-600",
          "outline-none",
          "placeholder:text-slate-400 dark:placeholder:text-slate-500",
          "focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-700 focus:ring-indigo-400 dark:focus:ring-indigo-400",
          className
        )}
        {...props}
      />
    </div>
  );
};

export default TextArea;
